import { observer } from 'mobx-react';

import {
  ButtonGroup,
  // FormControl,
  // FormLabel,
  HStack,
  // Input,
  // InputGroup,
  // InputLeftElement,
  Stack,
} from '@chakra-ui/react';
import * as React from 'react';

// import { BsSearch } from 'react-icons/bs';

export const TableActions = observer(
  ({ actions, conn, columns, tableStore }) => {
    const { leftActions, rightActions } = actions;
    const leftActionElements = leftActions?.map((Action, i) => {
      return (
        <Action key={i} conn={conn} columns={columns} tableStore={tableStore} />
      );
    });
    const rightActionElements = rightActions?.map((Action, i) => {
      return (
        <Action key={i} conn={conn} columns={columns} tableStore={tableStore} />
      );
    });

    return (
      <Stack
        spacing='4'
        direction={{
          base: 'column',
          md: 'row',
        }}
        justify='space-between'
      >
        <HStack>
          {leftActionElements}
          {/* <FormControl
          minW={{
            md: '320px',
          }}
          id='search'
        >
          <InputGroup size='sm'>
            <FormLabel srOnly>Filter by name or email</FormLabel>
            <InputLeftElement pointerEvents='none' color='gray.400'>
              <BsSearch />
            </InputLeftElement>
            <Input
              rounded='base'
              type='search'
              placeholder='Filter by name or email...'
            />
          </InputGroup>
        </FormControl> */}
        </HStack>
        <ButtonGroup size='sm' variant='outline'>
          {rightActionElements}
        </ButtonGroup>
      </Stack>
    );
  },
);
